(() => {
  if (customElements.get('tm-winner-embed')) return;
  const isHost = (host, domain) => host === domain || host.endsWith('.' + domain);
  // Public links only. Never inject user-supplied HTML or use an arbitrary iframe URL.
  function resolveEmbed(raw, kind, autoplay) {
    let url; try { url = new URL(raw); } catch { return null; }
    if (url.protocol !== 'https:' || url.username || url.password) return null;
    const host = url.hostname.toLowerCase(); let match;
    if (kind === 'direct') return {type: 'video', src: url.href};
    if (isHost(host, 'youtube.com') || host === 'youtu.be' || isHost(host, 'youtube-nocookie.com')) {
      const id = host === 'youtu.be' ? url.pathname.slice(1).split('/')[0] : url.searchParams.get('v') || url.pathname.match(/^\/(?:shorts|embed|live)\/([^/]+)/)?.[1];
      if (!id || !/^[A-Za-z0-9_-]{11}$/.test(id)) return null;
      return {type:'iframe',src:`https://www.youtube-nocookie.com/embed/${id}?autoplay=${autoplay?1:0}&mute=1&playsinline=1&rel=0`};
    }
    if (isHost(host, 'vimeo.com')) {
      const id = url.pathname.match(/(?:^|\/)(\d+)(?:\/|$)/)?.[1]; if (!id) return null;
      const privacy = url.searchParams.get('h') || url.pathname.match(/\/\d+\/([A-Za-z0-9]+)$/)?.[1];
      return {type:'iframe',src:`https://player.vimeo.com/video/${id}?autoplay=${autoplay?1:0}&muted=1&playsinline=1${privacy?'&h='+encodeURIComponent(privacy):''}`};
    }
    if (isHost(host, 'instagram.com') && (match=url.pathname.match(/^\/(p|reel|tv)\/([A-Za-z0-9_-]+)\/?/))) return {type:'iframe',src:`https://www.instagram.com/${match[1]}/${match[2]}/embed/`};
    if (isHost(host, 'tiktok.com') && (match=url.pathname.match(/\/video\/(\d+)/))) return {type:'iframe',src:`https://www.tiktok.com/player/v1/${match[1]}?autoplay=${autoplay?1:0}&muted=1`};
    if (isHost(host, 'facebook.com')) {
      if (url.pathname.startsWith('/share/')) return null;
      const video = /\/(?:reel|videos|watch)(?:\/|$)/.test(url.pathname) || url.searchParams.has('v');
      const src = new URL(`https://www.facebook.com/plugins/${video?'video':'post'}.php`);
      src.searchParams.set('href',url.href); src.searchParams.set('show_text',video?'false':'true');src.searchParams.set('width','500');
      if(video)src.searchParams.set('autoplay',autoplay?'true':'false');
      return {type:'iframe',src:src.href};
    }
    return null;
  }
  class WinnerEmbed extends HTMLElement {
    connectedCallback() {
      if(this.dataset.ready) return; this.dataset.ready='true';
      const target=this.querySelector('[data-media-player]');if(!target)return;
      const raw=this.dataset.url?.trim();if(!raw){this.querySelector('[data-media-empty]')?.removeAttribute('hidden');return;}
      const spec=resolveEmbed(raw,this.dataset.kind,this.dataset.autoplay==='true');
      const fallback=this.querySelector('[data-media-fallback]');
      let url;try{url=new URL(raw);}catch{}
      if(url?.protocol==='https:' && !url.username && !url.password && fallback){fallback.href=url.href;fallback.hidden=false;}
      if(!spec){this.querySelector('[data-media-unsupported]')?.removeAttribute('hidden');return;}
      const player=document.createElement(spec.type==='video'?'video':'iframe');
      if(spec.type==='video') {player.controls=true;player.muted=true;player.playsInline=true;player.autoplay=this.dataset.autoplay==='true';player.loop=this.dataset.loop==='true';player.preload='metadata';if(this.dataset.poster)player.poster=this.dataset.poster;}
      else {player.title=this.dataset.title||'Winner video or social post';player.loading=this.dataset.autoplay==='true'?'eager':'lazy';player.allow='autoplay; encrypted-media; fullscreen; picture-in-picture';player.allowFullscreen=true;player.referrerPolicy='strict-origin-when-cross-origin';}
      if(this.dataset.autoRatio === 'true' && spec.type === 'iframe') {
        const embedHost = new URL(spec.src).hostname;
        target.style.aspectRatio = embedHost.includes('tiktok.com') ? '9/16' : embedHost.includes('instagram.com') ? '4/5' : '16/9';
      }
      player.src=spec.src; target.appendChild(player);
    }
  }
  customElements.define('tm-winner-embed',WinnerEmbed);
})();
